import { fetchPosts } from '@/services/userService';

export const Single = {
  namespaced: true,
  state: {
    loaded: false,
    data: null,
    isError: null,
  },
  getters: {
    loaded: (state: any) => {
      return state.loaded;
    },
    data: (state: any) => {
      return state.data;
    },
    token: (state: any, getters: any, rootState: any, rootGetters: any) => {
      return rootGetters['auth/token'];
    },
    lang: (state: any, getters: any, rootState: any, rootGetters: any) => {
      return rootGetters['auth/lang'];
    },
  },
  mutations: {
    resetData: (state: any) => {
      state.data = null;
      state.isError = false;
    },
    logout: (state: any) => {
      state.loaded = false;
      state.data = null;
      state.isError = false;
    },
    setLoaded: (state: any, bool: boolean) => {
      state.loaded = bool;
    },
    setData: (state: any, data: PostData) => {
      state.data = data;
    },
    setError: (state: any, bool: boolean) => {
      state.isError = bool;
    },
  },
  actions: {
    getEntry: async (cxt: any, params: any) => {
      const result = await fetchPosts({
        cat: `${params.category}`,
        id: params.id,
        lang: `${cxt.getters.lang}`
      })
      .then( (response) => {
        if (response.datas[0] === undefined) {
          cxt.commit('setData', null);
          cxt.dispatch('head/updateTitle', null, {root: true});
        } else {
          cxt.commit('setData', response.datas[0]);
          cxt.dispatch('head/updateTitle', response.datas[0].title, {root: true});
        }
        cxt.commit('setLoaded', true);
        return response;
      })
      .catch( (e) => {
        console.error(e);
      });
      return result;
    },
  },
};
